import { render, staticRenderFns } from "./DiversificationMeasureSummary.vue?vue&type=template&id=0e15bdcc&scoped=true&"
import script from "./DiversificationMeasureSummary.vue?vue&type=script&lang=js&"
export * from "./DiversificationMeasureSummary.vue?vue&type=script&lang=js&"
import style0 from "./DiversificationMeasureSummary.vue?vue&type=style&index=0&id=0e15bdcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e15bdcc",
  null
  
)

export default component.exports